export const EmprestimoGarantiaTabs = {
  'emprestimo-garantia': {
    id: 0,
    href: 'emprestimo-garantia-carro',
    label: 'Empréstimo com garantia',
    navigate: true,
    t: '',
  },
  'emprestimo-garantia-contrato': {
    id: 1,
    href: 'emprestimo-garantia-carro',
    label: 'Já tenho contrato',
    navigate: true,
    t: 'contrato',
  },
};
